import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../rootReducer';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../services/api';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { FilterOperators, Ifilter } from '../../components/common/filters/interfaces';
import {
  actions as userListActions
} from '../users/list';
import { selectors as filterDashboardSelectors } from '../filters/dashboardFilters';
import { selectors as filterMenuSelectors } from '../filters/sideMenuFilters';
import { ListParams } from '../utils';
import { setActiveField } from '../../components/common/utils/activeStatus';
import { fetchAccountsList } from '../accounts/list.thunks';

export interface IUpdateUserStatusPayload {
  isActive: boolean;
  id: string;
  accountId: string;
  currentPage?: number;
}

export const updateUserStatusById: AsyncThunk<void, IUpdateUserStatusPayload, ThunkAPI> = createAsyncThunk(
  'users/updateStatus',
  async (user: IUpdateUserStatusPayload, thunk) => {
    try {
      const { currentPage = 1 } = user;
      delete user.currentPage;
      const response = await basicApiAsyncThunkCreator<void, IUpdateUserStatusPayload>({
        endpoint: 'users',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Patch,
        contentType: 'application/json'
      })(user, thunk);
      const state = thunk.getState();
      const entryStatus = filterDashboardSelectors.getEntryStatus(state);
      const request: ListParams<Ifilter[]> = {
        filters: filterMenuSelectors.getAppliedFilters(state),
        search: filterDashboardSelectors.getSearchFilters(state),
        sort: filterDashboardSelectors.getSorter(state),
        pagination: { offset: (currentPage - 1) * 25, limit: 25 },
        accountId: user.accountId
      };
      setActiveField(request, entryStatus);
      thunk.dispatch(userListActions.fetchUsersList(request));
      const fetchAccountsRequest: ListParams<Ifilter[]> = {
        filters: [
          {
            field: '_id',
            operands: [user.accountId],
            operator: FilterOperators.isAnyOf,
            validateInputs: false
          }
        ]
      };
      thunk.dispatch(fetchAccountsList(fetchAccountsRequest));
      thunk.dispatch(showSuccessMessage('User updated'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed, please try again later or contact support'));
      return thunk.rejectWithValue(err);
    }
  }
);
